'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _UserAuthenticationForm = require('./UserAuthenticationForm.scss');var styles = _interopRequireWildcard(_UserAuthenticationForm);

var _components = require('../../../components');






var _messageModal = require('../../../redux/modules/messageModal');


var _constants = require('../../../constants');
var _formatPhoneNumber = require('../../../utils/formatPhoneNumber');
var _validate = require('../../../utils/validate');



var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');
var _scrollTo = require('../../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
// Components
// Helpers
_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);var UserAuthenticationForm = function (_Component) {_inherits(UserAuthenticationForm, _Component);
  function UserAuthenticationForm(props) {_classCallCheck(this, UserAuthenticationForm);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.

























































































































    onCouponCodeChange = function (evt) {
      var value = evt.target.value;
      evt.target.value = value.trim();
      _this.setState({
        couponCodeIsValid: true });

    };_this.

    setWrapperRef = function (node) {
      _this.formRef = node;
    };_this.

    scrollTo = function (element) {var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true },
      options));

    };_this.

    fetchReCaptchaToken = function (evt) {
      _this.setState({ captcha: evt }, _this.handleSubmit);
    };_this.

    handleChangeIsAgent = function (evt) {return _this.setState({
        isAgent: evt.target.checked,
        companyLogo: {},
        companyNameFieldIsDirty: false,
        licenseNumberFieldIsDirty: false,
        doValidate: false });};_this.


    handleChangeAgree = function (event) {
      _this.setState({ agreeIsNotValid: false });
      _this.setState({ confirmThatIRead: event.target.checked });
      event.target.classList.remove('not_valid');
    };_this.

    handleSubmit = function (event) {
      event && event.preventDefault();
      var target = _this.formRef;
      _this.userAuthenticationData = {};var _this$props =









      _this.props,typeTab = _this$props.typeTab,emailIsValid = _this$props.emailIsValid,phoneIsValid = _this$props.phoneIsValid,editUserProfile = _this$props.editUserProfile,authenticateUser = _this$props.authenticateUser,userAuthentication = _this$props.userAuthentication,companyNameIsValid = _this$props.companyNameIsValid,licenseNumberIsValid = _this$props.licenseNumberIsValid;
      var isCheckPhone = _this.props.userAuthentication && _this.props.userAuthentication.isCheckPhone;
      var isNewAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;
      var firstValue = (0, _get2.default)(target, '[0].value');
      var code = (0, _get2.default)(target, '[1].value');
      var shouldShowFormPhone = !isNewAccountTab && firstValue && _this.props.phoneIsValid && _this.state.captcha;
      if (!firstValue.length) {
        return;
      }

      _this.setState({
        email: firstValue,
        passwordFieldIsDirty: true,
        emailFieldIsDirty: true,
        licenseNumberFieldIsDirty: true,
        companyNameFieldIsDirty: true,
        promoCodeFieldIsDirty: true,
        doValidate: true,
        emailIsValid: emailIsValid,
        phoneIsValid: phoneIsValid });


      if (shouldShowFormPhone && !isCheckPhone) {
        _this.props.checkPhone({
          captcha: _this.state.captcha,
          phone: (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(firstValue),
          locale: _this.props.locale });

        _this.setState({ captcha: null });
      }

      if (shouldShowFormPhone && isCheckPhone) {
        _this.props.authenticateUserByNumber({
          captcha: _this.state.captcha,
          phone: (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(firstValue),
          code: code });

        _this.setState({ captcha: null });
      }

      if (typeTab === _constants.userAuthenticationTabs.UPDATE_TEMPORARY_PROFILE) {
        if (emailIsValid) {
          var formattedEmail = firstValue.replace(/\s/g, '').toLowerCase();
          editUserProfile({
            userData: { email: formattedEmail },
            userToken: userAuthentication.data.access_token });

          // analytics
          (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.login, _analyticsConstants.eventAction.tempToRegular);
        } else {
          target[0].classList.add('not_valid');
        }
      } else {
        if (!_this.state.confirmThatIRead) {
          _this.setState(function (state) {return {
              agreeIsNotValid: true };});

          target.agree.classList.add('not_valid');
          if (emailIsValid && _this.state.passwordIsValid && companyNameIsValid && licenseNumberIsValid) {
            _this.scrollTo('agreeToTerms', {
              containerSelector: '.ReactModal__Content' });

          }
        }

        if (emailIsValid && _this.state.passwordIsValid && _this.state.confirmThatIRead) {
          for (var index = 0; index < target.length; index += 1) {
            if (target[index].tagName === 'INPUT') {
              switch (target[index].type) {
                case 'checkbox':
                  {
                    _this.userAuthenticationData[target[index].name] = target[index].checked;
                    break;
                  }
                default:
                  {
                    _this.userAuthenticationData[target[index].name] = target[index].value;
                  }}

            }
          }

          if (typeTab === _constants.userAuthenticationTabs.UPDATE_TEMPORARY_PROFILE) {
            editUserProfile({
              userData: {
                email: _this.userAuthenticationData.email.trim().toLowerCase() },

              userToken: userAuthentication.data.access_token });

          } else if (_this.userAuthenticationData.password && _this.userAuthenticationData.password.length && (
          !_this.state.isAgent ||
          _this.state.isAgent && licenseNumberIsValid && companyNameIsValid))
          {
            _this.userAuthenticationData.requestType = typeTab;
            _this.userAuthenticationData.profile_img = _this.state.companyLogo;
            _this.sendAnalyticsEvent();
            authenticateUser(_this.userAuthenticationData);
          }
        }
      }
    };_this.







    hideTooltip = function () {
      _this.setState({
        showError: false,
        doValidate: false });

    };_this.

    handleKeyDown = function (event) {
      if (event.target.name === 'password') {
        var submitButton = document.querySelector('.' + styles.authorization_buttons + ' > button');

        if (submitButton) {
          _this.props.triggerPressEnter(event.keyCode, submitButton);
        }
      }
    };_this.

    validationMark = function (isInvalid) {return _this.setState({ showError: isInvalid });};_this.

    defineEmailErrorMsg = function () {
      var errorMsg = '';
      if (_this.props.isTemporaryEmail) {
        errorMsg = _this.props.translate('errorMessageForTemporaryUser');
      } else if (!_this.props.emailIsValid) {
        errorMsg = _this.props.translate('emailTooltipMessage');
      } else {var
        error = _this.props.userAuthentication.error;
        errorMsg = error && (error.name === 'BadRequestError' || error.message.match(/email/i)) ?
        _this.props.translate('errorMessage') :
        '';
      }
      return errorMsg.toString();
    };_this.

    defineCouponErrorMsg = function () {
      var errorMsg = '';var
      error = _this.props.userAuthentication.error;
      if (error && error.message.match(/discount/i)) {
        errorMsg = _this.props.translate('discountCodeTooltip');
      }
      return _this.state.couponCodeIsValid ? '' : errorMsg.toString();
    };_this.

    changeImages = function (data) {
      var publicId = null;
      var image = data.length ? data[0] : {};

      if (data.length) {
        publicId = image.public_id ? image.public_id : image.full && image.full.split('/').pop();
      }

      var companyLogo = {
        link: publicId,
        angle: image.angle || 0 };


      // eslint-disable-next-line
      _this.setState(function (previousState) {
        return Object.assign({}, previousState, { companyLogo: companyLogo });
      });
    };_this.

    showInput = function () {return _this.setState({ showInput: true });};_this.

    renderLicenseNumberField = function () {
      var isNewAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;

      return isNewAccountTab && _this.state.isAgent &&
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.agentblock, 'form-group') },
        _react2.default.createElement(_components.OMInputField, {
          name: 'license_number',
          type: 'text',
          placeholder: '' + _this.props.translate('licenseNumber'),
          title: '' + _this.props.translate('licenseNumber'),
          validate: _this.props.validateLicenseNumber,
          doValidate: _this.state.doValidate,
          showHoverTooltip: !_this.props.licenseNumberIsValid && _this.state.licenseNumberFieldIsDirty,
          tooltipMessage: '' + _this.props.translate('licenseNumberTooltip'),
          fieldIsDirty: function fieldIsDirty(isDirty) {return _this.setState({ licenseNumberFieldIsDirty: isDirty });},
          isMobile: _this.props.isMobile,
          isValidIfEmpty: true,
          isRtl: _this.props.isRtl,
          onFocus: _this.hideTooltip,
          validationMark: _this.validationMark,
          isInvalid: !_this.props.licenseNumberIsValid && _this.state.licenseNumberFieldIsDirty && _this.state.showError,
          onChange: function onChange(evt) {
            var value = evt.target.value;
            evt.target.value = value.replace(/[\D]/g, '');
          } }));



    };_this.

    renderCodeField = function () {
      var isCheckPhone = _this.props.userAuthentication && _this.props.userAuthentication.isCheckPhone;
      var showCodeField = _this.props.phoneIsValid && isCheckPhone && _this.state.email;

      if (!showCodeField) {
        return null;
      }

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.agentblock, 'form-group') },
          _react2.default.createElement(_components.OMInputField, {
            name: 'code',
            type: 'text',
            placeholder: '' + _this.props.translate('tabCode'),
            isMobile: _this.props.isMobile,
            isRtl: _this.props.isRtl,
            onFocus: _this.hideTooltip,
            validationMark: _this.validationMark,
            onChange: function onChange(evt) {
              var value = evt.target.value;
              evt.target.value = value.replace(/[\D]/g, '');
            } })));



    };_this.

    renderCompanyNameField = function () {
      var isNewAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;

      return isNewAccountTab && _this.state.isAgent &&
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.agentblock, 'form-group') },
        _react2.default.createElement(_components.OMInputField, {
          name: 'company_name',
          type: 'text',
          placeholder: '' + _this.props.translate('companyName'),
          title: '' + _this.props.translate('companyName'),
          validate: _this.props.validateCompanyName,
          doValidate: _this.state.doValidate,
          showHoverTooltip: !_this.props.companyNameIsValid && _this.state.companyNameFieldIsDirty,
          tooltipMessage: '' + _this.props.translate('companyNameTooltip'),
          fieldIsDirty: function fieldIsDirty(isDirty) {return _this.setState({ companyNameFieldIsDirty: isDirty });},
          isMobile: _this.props.isMobile,
          isValidIfEmpty: true,
          isRtl: _this.props.isRtl,
          onFocus: _this.hideTooltip,
          validationMark: _this.validationMark,
          isInvalid: !_this.props.companyNameIsValid && _this.state.companyNameFieldIsDirty && _this.state.showError }));



    };_this.

    renderCompanyLogo = function () {
      var isNewAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;

      return isNewAccountTab && _this.state.isAgent &&
      _react2.default.createElement('div', { className: 'form-group' },
        _react2.default.createElement('div', { className: styles.uploadWidget },
          _react2.default.createElement('div', { className: styles.widget },
            _react2.default.createElement(_components.UploadAssetWidget, {
              className: 'userAuthenticationForm',
              openMessageModal: _messageModal.openMessageModal,
              rootTranslate: _this.props.rootTranslate,
              translate: _this.props.rootTranslate('uploadWidget'),
              isMobile: _this.props.isMobile,
              uploadInProgress: function uploadInProgress(status) {return _this.setState({ uploadPhotoInProgress: status });},
              updateContent: _this.changeImages,
              contentUploaded: _this.changeImages,
              directUploadToCLoudinary: true }))));





    };_this.

    renderPasswordInput = function () {var
      typeTab = _this.props.typeTab;
      var isNewAccountTab = typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;
      var showInput = isNewAccountTab || !_this.state.phoneIsValid || !_this.state.isFirstValue;

      if (!showInput) {
        return null;
      }

      return (
        _react2.default.createElement('div', { className: 'form-group' },
          _react2.default.createElement(_components.OMInputField, {
            name: 'password',
            type: 'password',
            placeholder: '' + _this.props.translate('passwordFieldPlaceholder'),
            title: '' + _this.props.translate('passwordTitle'),
            onFocus: _this.hideTooltip,
            validate: _this.props.validatePassword,
            showHoverTooltip: !_this.state.passwordIsValid,
            tooltipMessage: '' + _this.props.translate('passwordTooltipMessage'),
            fieldIsDirty: function fieldIsDirty(isDirty) {return _this.setState(function (prev) {return Object.assign({}, prev, { passwordFieldIsDirty: isDirty });});},
            doValidate: _this.state.doValidate,
            isMobile: _this.props.isMobile,
            hidePasswordTitle: '' + _this.props.translate('hidePassword'),
            revealPasswordTitle: '' + _this.props.translate('revealPassword'),
            isValidIfEmpty: true,
            isRtl: _this.props.isRtl,
            showErrorMessageDesktop: true })));



    };_this.

    renderErrorMessage = function () {var _this$props2 =
      _this.props,translate = _this$props2.translate,_this$props2$userAuth = _this$props2.userAuthentication,errorCheckPhone = _this$props2$userAuth.errorCheckPhone,errorPhoneCode = _this$props2$userAuth.errorPhoneCode;

      if (errorCheckPhone) {
        return translate('thisPhoneNumberIsNotVerified');
      }
      if (errorPhoneCode) {
        return translate('incorrectCode');
      }

      return translate('errorMessage');
    };_this.

    renderPromoCodeButton = function () {
      var isNewAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;
      return isNewAccountTab && _this.state.isAgent && !_this.state.showInput &&
      _react2.default.createElement('div', { className: styles.couponButton },
        _react2.default.createElement('span', null, _this.props.rootTranslate('discountCoupon', 'haveCoupon'), ',\xA0'),
        _react2.default.createElement('span', { className: styles.actionButton, onClick: _this.showInput }, _this.props.rootTranslate('discountCoupon', 'clickHere')));


    };_this.

    renderPromoCodeField = function () {
      var isNewAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;
      return isNewAccountTab && _this.state.isAgent && _this.state.showInput &&
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.agentblock, 'form-group') },
        _react2.default.createElement(_components.OMInputField, {
          name: 'discount_code',
          type: 'text',
          placeholder: '' + _this.props.translate('discountCode'),
          title: '' + (_this.defineCouponErrorMsg() || _this.props.translate('discountCode')),
          doValidate: false,
          fieldIsDirty: function fieldIsDirty(isDirty) {return _this.setState({ promoCodeFieldIsDirty: isDirty });},
          isMobile: _this.props.isMobile,
          isValidIfEmpty: true,
          isRtl: _this.props.isRtl,
          onFocus: _this.hideTooltip,
          validationMark: _this.validationMark,
          isInvalid: !!_this.defineCouponErrorMsg() && _this.state.promoCodeFieldIsDirty,
          showHoverTooltip: _this.state.promoCodeFieldIsDirty,
          tooltipMessage: _this.defineCouponErrorMsg(),
          onChange: _this.onCouponCodeChange }));



    };_this.

    renderButton = function () {
      var withCaptcha = _this.state.emailIsValid;
      var loadingUserData = _this.props.userAuthentication && _this.props.userAuthentication.loading;

      return _react2.default.createElement('div', { className: styles.buttonWrapper },
        !withCaptcha ? _react2.default.createElement(_components.GoogleReCaptcha, {
            locale: _this.props.locale,
            fetchToken: _this.fetchReCaptchaToken,
            captchaIdentifier: 'UserAuthenticationForm' + _this.props.typeTab,
            doReset: loadingUserData,
            userAuthentication: true },

          _react2.default.createElement('button', {
              className: 'btn btn-primary',
              onClick: _this.state.captcha && _this.handleSubmit,
              disabled: loadingUserData },

            loadingUserData ?
            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
            _react2.default.createElement('span', { className: 'button-text' }, _this.props.translate('buttonTitle')))) :

        _react2.default.createElement('button', {
            className: 'btn btn-primary',
            onClick: _this.handleSubmit,
            disabled: loadingUserData },

          loadingUserData ?
          _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
          _react2.default.createElement('span', { className: 'button-text' }, _this.props.translate('buttonTitle'))));


    };_this.

    renderEmailInput = function () {var _cx;
      var isNewAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT;
      var isSignInTab = _this.props.typeTab === _constants.userAuthenticationTabs.SIGN_IN;
      var isTemporaryAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.UPDATE_TEMPORARY_PROFILE;
      var isErrorCanBeShown = isNewAccountTab || isTemporaryAccountTab;

      var handleChange = function handleChange(evt) {var
        value = evt.target.value;
        var isEmpty = !value || value && value.length === 0;
        var trimmedValue = value ? value.replace(/\s/g, '') : '';

        var emailIsValid = (0, _validate.emailRegexValidation)(trimmedValue);
        var phoneIsValid = (0, _validate.phoneRegexValidation)(trimmedValue);
        var isInvalidInput = !emailIsValid || !phoneIsValid || isEmpty;

        if (isInvalidInput && _this.props.clearUserAuthentication) {
          _this.props.clearUserAuthentication();
        }

        _this.setState(function (prev) {return Object.assign({},
          prev, {
            isFirstValue: !!value.length,
            captcha: !phoneIsValid ? null : prev.captcha,
            emailIsValid: isEmpty ? false : emailIsValid,
            phoneIsValid: isEmpty ? false : phoneIsValid });});

      };

      return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)((_cx = {}, _cx[
            styles.phoneInput] = (_this.state.phoneIsValid || !_this.state.isFirstValue) && isSignInTab, _cx),
            'form-group'),

            ref: function ref(email) {_this.email = email;} },

          _react2.default.createElement(_components.OMInputField, {
            name: 'email',
            type: isNewAccountTab ? 'email' : 'text',
            placeholder: '' + _this.props.translate('emailFieldPlaceholder'),
            title: _this.defineEmailErrorMsg(),
            onFocus: _this.hideTooltip,
            validate: _this.props.validateEmail,
            isInvalid: isErrorCanBeShown ? !!(_this.defineEmailErrorMsg() && _this.state.showError) : false,
            showHoverTooltip: _this.state.emailFieldIsDirty &&
            !!(_this.defineEmailErrorMsg() || !_this.props.emailIsValid),
            tooltipMessage: _this.defineEmailErrorMsg(),
            fieldIsDirty: function fieldIsDirty(isDirty) {return _this.setState(function (prev) {return Object.assign({}, prev, { emailFieldIsDirty: isDirty });});},
            doValidate: _this.state.doValidate,
            isMobile: _this.props.isMobile,
            onChange: handleChange,
            isValidIfEmpty: true,
            isRtl: _this.props.isRtl,
            validationMark: _this.validationMark,
            showErrorMessageDesktop: true })));



    };_this.

    render = function () {var _cx2, _cx3, _cx4;
      var isTemporaryAccountTab = _this.props.typeTab === _constants.userAuthenticationTabs.UPDATE_TEMPORARY_PROFILE;

      return (
        // eslint-disable-next-line
        _react2.default.createElement('form', {
            className: styles.authentication_form,
            onKeyDown: _this.handleKeyDown,
            onSubmit: _this.handleSubmit,
            ref: _this.setWrapperRef },

          _react2.default.createElement('div', { className: styles.loginBlock },
            _this.renderEmailInput(),
            _this.renderPasswordInput()),

          _this.checkbox,

          _this.renderCodeField(),
          _this.renderLicenseNumberField(),
          _this.renderCompanyNameField(),
          _this.renderPromoCodeButton(),
          _this.renderPromoCodeField(),
          _this.renderCompanyLogo(),

          isTemporaryAccountTab && _this.props.isMobile && _this.state.showError &&
          _react2.default.createElement('div', { className: styles.temporaryError }, _this.defineEmailErrorMsg()),

          _react2.default.createElement(_reactScroll.Element, {
              className: (0, _classnames2.default)((_cx2 = {}, _cx2[
              styles.agreeIsNotValid] = _this.state.agreeIsNotValid, _cx2)),

              name: 'agreeToTerms' },

            _this.link),

          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.authorization_buttons, (_cx3 = {}, _cx3[
              styles.temporaryUserAuth] = isTemporaryAccountTab, _cx3),
              'form-group') },


            _this.renderButton(),

            _this.props.typeTab === _constants.userAuthenticationTabs.SIGN_IN && _this.state.showError &&
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.errorMessage, (_cx4 = {}, _cx4[styles.errorMessageMobile] = _this.props.isMobile, _cx4)) },
              _this.renderErrorMessage()))));





    };_this.handleSubmit = _this.handleSubmit.bind(_this);_this.state = { showError: false, errorMessage: false, passwordIsValid: false, couponCodeIsValid: true, confirmThatIRead: props.typeTab === _constants.userAuthenticationTabs.UPDATE_TEMPORARY_PROFILE, passwordFieldIsDirty: false, emailFieldIsDirty: false, licenseNumberFieldIsDirty: false, companyNameFieldIsDirty: false, promoCodeFieldIsDirty: false, doValidate: false, isAgent: false, companyLogo: {}, showInput: false, agreeIsNotValid: false, captcha: null, email: null, emailIsValid: false, phoneIsValid: false, isFirstValue: false };return _this;}UserAuthenticationForm.prototype.componentWillMount = function componentWillMount() {if (this.props.typeTab !== _constants.userAuthenticationTabs.UPDATE_TEMPORARY_PROFILE) {if (this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT) {this.link = _react2.default.createElement('div', { className: styles.form_link }, _react2.default.createElement(_components.OMCheckbox, { id: 'agree', field: { name: 'agree', onChange: this.handleChangeAgree }, label: _react2.default.createElement('span', null, _react2.default.createElement('span', null, this.props.translate('confirmThatIRead')), '\xA0', _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(this.props.locale, '/terms'), target: '_blank' }, this.props.translate('termsOfUse')), '\xA0', _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(this.props.locale, '/privacy'), target: '_blank' }, this.props.translate('privacy'))) }));this.checkbox = _react2.default.createElement(_components.OMCheckbox, { id: 'is_agent', className: (0, _classnames2.default)('is_agent_checkbox', styles.isAgentCheckbox), field: { name: 'is_agent', onChange: this.handleChangeIsAgent }, label: _react2.default.createElement('span', null, _react2.default.createElement('span', null, this.props.translate('professionalConfirmation')), _react2.default.createElement(_components.BottomTooltip, { msg: this.props.translate('realEstateTooltip'), className: 'realEstateTooltip' })) });} else {this.setState({ confirmThatIRead: true });this.checkbox = null;this.link = _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.form_link, styles.forgotPassword) }, _react2.default.createElement('a', { onClick: this.props.forgotPassword }, this.props.translate('forgotPassword')));}}};UserAuthenticationForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var emailIsValid = _ref.emailIsValid,passwordIsValid = _ref.passwordIsValid,phoneIsValid = _ref.phoneIsValid,userAuthentication = _ref.userAuthentication,formIsActive = _ref.formIsActive;if (passwordIsValid !== this.state.passwordIsValid) {this.setState({ passwordIsValid: passwordIsValid });}if (userAuthentication.error && userAuthentication.error.message.match(/discount/i) && userAuthentication.error !== this.props.userAuthentication.error) {this.setState({ couponCodeIsValid: false });}var showError = false;var errorEvent = _analyticsConstants.eventAction.login;if (this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT) {errorEvent = _analyticsConstants.eventAction.register;}if (!formIsActive && this.props.formIsActive) {showError = false;}if (!emailIsValid && emailIsValid !== this.props.emailIsValid && this.props.isMobile) {showError = true;}if (userAuthentication.error && this.props.userAuthentication.error) {// analytics
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.error, errorEvent, userAuthentication.error.message);if (userAuthentication.error.message !== this.props.userAuthentication.error.message) {showError = true;}} else if (userAuthentication.error) {// analytics
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.error, errorEvent, userAuthentication.error.message);showError = true;}this.setState({ showError: showError });};UserAuthenticationForm.prototype.sendAnalyticsEvent = function sendAnalyticsEvent() {if (this.props.typeTab === _constants.userAuthenticationTabs.NEW_ACCOUNT) {(0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.newAccount, _analyticsConstants.eventAction.create);}};return UserAuthenticationForm;}(_react.Component);exports.default = UserAuthenticationForm;
UserAuthenticationForm.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  typeTab: _propTypes2.default.number,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  forgotPassword: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  checkPhone: _propTypes2.default.func,
  authenticateUserByNumber: _propTypes2.default.func,
  userAuthentication: _propTypes2.default.object,
  validateEmail: _propTypes2.default.func,
  validatePassword: _propTypes2.default.func,
  validateLicenseNumber: _propTypes2.default.func,
  triggerPressEnter: _propTypes2.default.func,
  emailIsValid: _propTypes2.default.bool,
  phoneIsValid: _propTypes2.default.bool,
  passwordIsValid: _propTypes2.default.bool,
  licenseNumberIsValid: _propTypes2.default.bool,
  formIsActive: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  editUserProfile: _propTypes2.default.func,
  isTemporaryEmail: _propTypes2.default.bool,
  validateCompanyName: _propTypes2.default.func,
  companyNameIsValid: _propTypes2.default.bool,
  clearUserAuthentication: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/UserAuthenticationForm/UserAuthenticationForm.js
// module id = 1239
// module chunks = 0